import { render, staticRenderFns } from "./customTabs.vue?vue&type=template&id=23d9a396&scoped=true"
import script from "./customTabs.vue?vue&type=script&lang=js"
export * from "./customTabs.vue?vue&type=script&lang=js"
import style0 from "./customTabs.vue?vue&type=style&index=0&id=23d9a396&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d9a396",
  null
  
)

export default component.exports